import { render, staticRenderFns } from "./enter_the_enclosure.vue?vue&type=template&id=5843c6ad"
import script from "./enter_the_enclosure.vue?vue&type=script&lang=js"
export * from "./enter_the_enclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports